import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { id } from '@wonder-core-ng/interfaces/id.type';
import { IQueryConfigData } from '../query-engine/interfaces/query.interface';
import { QueryConfigActions } from './query-config.actions';
import { selectQueryConfigData } from './query-config.selectors';

@Injectable({
  providedIn: 'root',
})
export class QueryConfigService {
  private readonly store = inject(Store);


  public queryConfig = this.store.selectSignal(selectQueryConfigData);
  public get queryConfig$() {
    return this.store.select(selectQueryConfigData);
  }

  public saveQueryConfig(queryConfigData: IQueryConfigData, tenantId: id): void {
    this.store.dispatch(QueryConfigActions.saveQueryConfig({ queryConfigData, tenantId }));
  }
}
